import {Button, Col, Row, Tag} from "antd";
import Content from "./content";
import Package from "./package";

const ChoosePackage = () => {

    return (
        <Row gutter={24} className={"customer_row_marx"}>
            <Package namePackage={"Gói cơ bản"}
                     propose={true}
                     money={"150.000 đ/tháng"}
                     pay={"Thanh toán hằng tháng"}
                     textButton={"Nâng cấp"}
                     text3={"Quản lý 1 trạm cân"}
                     text4={"Tối đa 2 người dùng"} />

            <Package namePackage={"Gói tiêu chuẩn"}
                     propose={false}
                     money={"300.000 đ/tháng"}
                     pay={"Thanh toán hằng tháng"}
                     textButton={"Nâng cấp"}
                     text3={"Quản lý 2 trạm cân"}
                     text4={"Tối đa 5 người dùng"} />

            <Package namePackage={"Gói cao cấp"}
                     propose={false}
                     money={"500.000 đ/tháng"}
                     pay={"Thanh toán hằng tháng"}
                     textButton={"Nâng cấp"}
                     text3={"Quản lý 5 trạm cân"}
                     text4={"Không giới hạn người dùng"} />
        </Row>
    )
}

export default ChoosePackage
